// 平台
import OrganizationStaffInfo from '@/views/platform/OrganizationStaffInfo.vue';
import CommunityInfo from '@/views/platform/CommunityInfo.vue';
import MemberInfo from '@/views/platform/vip/vip/info.vue';
import AccountInfo from '@/views/platform/AccountInfo.vue';
import RoleInfo from '@/views/platform/RoleInfo.vue';
import VersionInfo from '@/views/platform/VersionInfo.vue';
import IntegralLog from '@/views/platform/vip/vip/integralLog.vue';
import CreateGoods from '@/views/platform/goods/CreateGoods'
import CreateComplaint from '@/views/platform/complaint/CreateComplaint'
import ComplaintDetial from '@/views/platform/complaint/ComplaintDetial'
import CreateNews from '@/views/platform/news/CreateNews'
//新增
import DeviceTypeInfo from '@/views/platform/DeviceTypeInfo.vue';//新增类型
import NewEquipmentInfo from '@/views/platform/NewEquipmentInfo.vue';//新增设备
import VendorsInfo from '@/views/platform/VendorsInfo.vue';//新增厂商
import NewMaintTaskInfo from '@/views/platform/NewMaintTaskInfo.vue';//维保新增任务
import NewInspTaskInfo from '@/views/platform/NewInspTaskInfo.vue';//巡检新增任务

// 社区
import HouseTypeInfo from '@/views/community/HouseTypeInfo.vue';
import BuildingInfo from '@/views/community/BuildingInfo.vue';
import PropertyNoticeInfo from '@/views/community/PropertyNoticeInfo.vue';
import ActivityInfo from '@/views/community/ActivityInfo.vue';
import QuestionnaireInfo from '@/views/community/QuestionnaireInfo.vue';
import ActivitySignUpManage from '@/views/community/ActivitySignUpManage.vue';
import QuestionnaireRecoverData from '@/views/community/QuestionnaireRecoverData.vue';
import QuestionnaireDataStatistics from '@/views/community/QuestionnaireDataStatistics.vue';
import RotationInfo from '@/views/community/RotationInfo.vue';
import ResidentInfo from '@/views/community/ResidentInfo.vue';
import TopicInfo from '@/views/community/TopicInfo.vue';
import InvitationInfo from '@/views/community/InvitationInfo.vue';
import RepairItemsInfo from '@/views/community/RepairItemsInfo.vue';
import ServiceProjectInfo from '@/views/community/ServiceProjectInfo.vue';
import RepairOrderInfo from '@/views/community/RepairOrderInfo.vue';
import RepairOrderDetail from '@/views/community/RepairOrderDetail.vue';
import FormulaInfo from '@/views/community/FormulaInfo.vue';
import ExpendInfo from '@/views/community/ExpendInfo.vue';
import ParkingAreaInfo from '@/views/community/ParkingAreaInfo.vue';
import ParkingLog from '@/views/community/ParkingLog.vue';
import ParkingRegister from '@/views/community/ParkingRegister.vue';
// import VendorsIfo from '@/views/community/VendorsInfo.vue'

export default {
  //厂商管理
  'platform/VendorManage': [
    {
      path: 'vendor-manage/new',
      name: 'NewVendors',
      component: VendorsInfo,
      meta: {
        title: '新增厂商'
      }
    },
    {
      path: 'vendor-manage/edit/:id',
      name: 'EditVendors',
      component: VendorsInfo,
      meta: {
        title: '编辑厂商'
      }
    }
  ],



  //新增类型
  'platform/DeviceType': [
    {
      path: 'device-type/new',
      name: 'NewType',
      component: DeviceTypeInfo,
      meta: {
        title: '新增类型'
      }
    },
    {
      path: 'device-type/edit/:id',
      name: 'EditType',
      component: DeviceTypeInfo,
      meta: {
        title: '编辑类型'
      }
    }
  ],
  //巡检新增任务
  'platform/InspectionTask': [
    {
      path: 'inspection-task/new',
      name: 'NewInspTask',
      component: NewInspTaskInfo,
      meta: {
        title: '新增任务'
      }
    },
    {
      path: 'inspection-task/edit/:id',
      name: 'EditInspTask',
      component: NewInspTaskInfo,
      meta: {
        title: '编辑任务'
      }
    }
  ],
  //维保新增任务
  'platform/MaintenanceTask': [
    {
      path: 'maintenance-task/new',
      name: 'NewMaintTask',
      component: NewMaintTaskInfo,
      meta: {
        title: '新增任务'
      }
    },
    {
      path: 'maintenance-task/edit/:id',
      name: 'EditMaintTask',
      component: NewMaintTaskInfo,
      meta: {
        title: '编辑任务'
      }
    }
  ],
  //新增设备
  'platform/EquipmentLedger': [
    {
      path: 'equipment-ledger/new',
      name: 'NewEquipment',
      component: NewEquipmentInfo,
      meta: {
        title: '新增设备'
      }
    },
    {
      path: 'equipment-ledger/edit/:id',
      name: 'EditEquipment',
      component: NewEquipmentInfo,
      meta: {
        title: '编辑设备'
      }
    }
  ],

  // 组织架构
  'platform/OrganizationManage': [
    {
      path: 'organization_manage/staff/new',
      name: 'NewOrganizationStaff',
      component: OrganizationStaffInfo,
      meta: {
        title: '新增员工'
      }
    },
    {
      path: 'organization_manage/staff/edit/:id',
      name: 'EditOrganizationStaff',
      component: OrganizationStaffInfo,
      meta: {
        title: '编辑员工'
      }
    }
  ],
  //社区管理
  'platform/CommunityManage': [
    {
      path: 'community_manage/new',
      name: 'NewCommunity',
      component: CommunityInfo,
      meta: {
        title: '新增社区'
      }
    },
    {
      path: 'community_manage/edit/:id',
      name: 'EditCommunity',
      component: CommunityInfo,
      meta: {
        title: '编辑社区'
      }
    }
  ],

  //角色管理
  'platform/RoleManage': [
    {
      path: 'role_manage/new',
      name: 'NewRole',
      component: RoleInfo,
      meta: {
        title: '新增角色'
      }
    },
    {
      path: 'role_manage/edit/:id',
      name: 'EditRole',
      component: RoleInfo,
      meta: {
        title: '编辑角色'
      }
    }
  ],
  //账号管理
  'platform/AccountManage': [
    {
      path: 'account_manage/new',
      name: 'NewAccount',
      component: AccountInfo,
      meta: {
        title: '新增账号'
      }
    },
    {
      path: 'account_manage/edit/:id',
      name: 'EditAccount',
      component: AccountInfo,
      meta: {
        title: '编辑账号'
      }
    }
  ],
  //版本管理
  'platform/VersionManage': [
    {
      path: 'version_manage/new',
      name: 'NewVersion',
      component: VersionInfo,
      meta: {
        title: '新增版本'
      }
    },
    {
      path: 'version_manage/edit/:id',
      name: 'EditVersion',
      component: VersionInfo,
      meta: {
        title: '编辑版本'
      }
    }
  ],
  //会员管理
  'platform/vip': [
    {
      path: 'vip/detail/:id',
      name: 'vip-detail',
      component: MemberInfo,
      meta: {
        title: '会员详情'
      }
    },
    {
      path: 'vip/integral_log/:id',
      name: 'MemberIntegralLog',
      component: IntegralLog,
      meta: {
        title: '会员积分日志'
      }
    }
  ],
  //户型管理
  'platform/HouseTypeManage': [
    {
      path: 'house_type_manage/new',
      name: 'NewHouseType',
      component: HouseTypeInfo,
      meta: {
        title: '新增户型'
      }
    },
    {
      path: 'house_type_manage/edit/:id',
      name: 'EditHouseType',
      component: HouseTypeInfo,
      meta: {
        title: '编辑户型'
      }
    }
  ],
  //社区 户型管理
  'community/HouseTypeManage': [
    {
      path: 'house_type_manage/new',
      name: 'NewHouseType',
      component: HouseTypeInfo,
      meta: {
        title: '新增户型'
      }
    },
    {
      path: 'house_type_manage/edit/:id',
      name: 'EditHouseType',
      component: HouseTypeInfo,
      meta: {
        title: '编辑户型'
      }
    }
  ],
  //平台 房源管理
  'platform/BuildingManage': [
    {
      path: 'building_manage/new',
      name: 'NewBuilding',
      component: BuildingInfo,
      meta: {
        title: '新增房源'
      }
    },
    {
      path: 'building_manage/edit/:id',
      name: 'EditBuilding',
      component: BuildingInfo,
      meta: {
        title: '编辑房源'
      }
    },
  ],
  //平台 商品管理
  'platform/GoodsListPage': [
    {
      path: 'goodslist/new',
      name: 'NewGoods',
      component: CreateGoods,
      meta: {
        title: '新建商品'
      }
    },
    {
      path: 'goodslist/new/:id',
      name: 'EditGoods',
      component: CreateGoods,
      meta: {
        title: '编辑商品'
      }
    },
  ],
  //平台 文章管理
  'platform/NewsList': [
    {
      path: 'newslist/new',
      name: 'NewNews',
      component: CreateNews,
      meta: {
        title: '新建文章'
      }
    },
    {
      path: 'newslist/new/:id',
      name: 'EditNews',
      component: CreateNews,
      meta: {
        title: '编辑文章'
      }
    },
  ],
  //平台 投诉管理
  'platform/ComplaintList': [
    {
      path: 'complaintlist/new',
      name: 'NewComplaint',
      component: CreateComplaint,
      meta: {
        title: '新建工单'
      }
    },
    {
      path: 'complaintlist/new/:id',
      name: 'EditComplaintList',
      component: ComplaintDetial,
      meta: {
        title: '工单详情'
      }
    },
  ],
  //社区 房源管理
  'community/BuildingManage': [
    {
      path: 'building_manage/new',
      name: 'NewBuilding',
      component: BuildingInfo,
      meta: {
        title: '新增房源'
      }
    },
    {
      path: 'building_manage/edit/:id',
      name: 'EditBuilding',
      component: BuildingInfo,
      meta: {
        title: '编辑房源'
      }
    }
  ],
  //业主管理
  'platform/ResidentManage': [
    {
      path: 'resident_manage/new',
      name: 'NewResident',
      component: ResidentInfo,
      meta: {
        title: '新增住户'
      }
    },
    {
      path: 'resident_manage/edit/:id',
      name: 'EditResident',
      component: ResidentInfo,
      meta: {
        title: '编辑住户'
      }
    }
  ],
  //业主管理
  'community/ResidentManage': [
    {
      path: 'resident_manage/new',
      name: 'NewResident',
      component: ResidentInfo,
      meta: {
        title: '新增住户'
      }
    },
    {
      path: 'resident_manage/edit/:id',
      name: 'EditResident',
      component: ResidentInfo,
      meta: {
        title: '编辑住户'
      }
    }
  ],
  //物业公告
  'platform/PropertyNotice': [
    {
      path: 'property_notice/new',
      name: 'NewPropertyNotice',
      component: PropertyNoticeInfo,
      meta: {
        title: '新增物业公告'
      }
    },
    {
      path: 'property_notice/edit/:id',
      name: 'EditPropertyNotice',
      component: PropertyNoticeInfo,
      meta: {
        title: '编辑物业公告'
      }
    }
  ],
  //物业公告
  'community/PropertyNotice': [
    {
      path: 'property_notice/new',
      name: 'NewPropertyNotice',
      component: PropertyNoticeInfo,
      meta: {
        title: '新增物业公告'
      }
    },
    {
      path: 'property_notice/edit/:id',
      name: 'EditPropertyNotice',
      component: PropertyNoticeInfo,
      meta: {
        title: '编辑物业公告'
      }
    }
  ],
  //社区活动
  'community/CommunityActivity': [
    {
      path: 'community_activity/activity/new',
      name: 'NewActivity',
      component: ActivityInfo,
      meta: {
        title: '新增活动'
      }
    },
    {
      path: 'community_activity/questionnaire/new',
      name: 'NewQuestionnaire',
      component: QuestionnaireInfo,
      meta: {
        title: '新增问卷'
      }
    },
    {
      path: 'community_activity/activity/edit/:id',
      name: 'EditActivity',
      component: ActivityInfo,
      meta: {
        title: '编辑活动'
      }
    },
    {
      path: 'community_activity/questionnaire/edit/:id',
      name: 'EditQuestionnaire',
      component: QuestionnaireInfo,
      meta: {
        title: '编辑问卷'
      }
    },
    {
      path: 'community_activity/activity/:id/sign_up_manage',
      name: 'ActivitySignUpManage',
      component: ActivitySignUpManage,
      meta: {
        title: '报名管理'
      }
    },
    {
      path: 'community_activity/questionnaire/:id/recover_data',
      name: 'QuestionnaireRecoverData',
      component: QuestionnaireRecoverData,
      meta: {
        title: '回收数据'
      }
    },
    {
      path: 'community_activity/questionnaire/:id/data_statistics',
      name: 'QuestionnaireDataStatistics',
      component: QuestionnaireDataStatistics,
      meta: {
        title: '数据统计'
      }
    },
  ],
  'platform/CommunityActivity': [
    {
      path: 'community_activity/activity/new',
      name: 'NewActivity',
      component: ActivityInfo,
      meta: {
        title: '新增活动'
      }
    },
    {
      path: 'community_activity/questionnaire/new',
      name: 'NewQuestionnaire',
      component: QuestionnaireInfo,
      meta: {
        title: '新增问卷'
      }
    },
    {
      path: 'community_activity/activity/edit/:id',
      name: 'EditActivity',
      component: ActivityInfo,
      meta: {
        title: '编辑活动'
      }
    },
    {
      path: 'community_activity/questionnaire/edit/:id',
      name: 'EditQuestionnaire',
      component: QuestionnaireInfo,
      meta: {
        title: '编辑问卷'
      }
    },
    {
      path: 'community_activity/activity/:id/sign_up_manage',
      name: 'ActivitySignUpManage',
      component: ActivitySignUpManage,
      meta: {
        title: '报名管理'
      }
    },
    {
      path: 'community_activity/questionnaire/:id/recover_data',
      name: 'QuestionnaireRecoverData',
      component: QuestionnaireRecoverData,
      meta: {
        title: '回收数据'
      }
    },
    {
      path: 'community_activity/questionnaire/:id/data_statistics',
      name: 'QuestionnaireDataStatistics',
      component: QuestionnaireDataStatistics,
      meta: {
        title: '数据统计'
      }
    },
  ],
  'platform/TopicManage': [
    {
      path: 'topic_manage/new',
      name: 'NewTopic',
      component: TopicInfo,
      meta: {
        title: '新增话题'
      }
    },
    {
      path: 'topic_manage/edit/:id',
      name: 'EditTopic',
      component: TopicInfo,
      meta: {
        title: '编辑话题'
      }
    }
  ],
  //话题管理
  'community/TopicManage': [
    {
      path: 'topic_manage/new',
      name: 'NewTopic',
      component: TopicInfo,
      meta: {
        title: '新增话题'
      }
    },
    {
      path: 'topic_manage/edit/:id',
      name: 'EditTopic',
      component: TopicInfo,
      meta: {
        title: '编辑话题'
      }
    }
  ],
  //话题管理
  'platform/InvitationManage': [
    {
      path: 'invitation_manage/new',
      name: 'NewInvitation',
      component: InvitationInfo,
      meta: {
        title: '新增帖子'
      }
    },
    {
      path: 'invitation_manage/edit/:id',
      name: 'EditInvitation',
      component: InvitationInfo,
      meta: {
        title: '编辑帖子'
      }
    }
  ],
  'community/InvitationManage': [
    {
      path: 'invitation_manage/new',
      name: 'NewInvitation',
      component: InvitationInfo,
      meta: {
        title: '新增帖子'
      }
    },
    {
      path: 'invitation_manage/edit/:id',
      name: 'EditInvitation',
      component: InvitationInfo,
      meta: {
        title: '编辑帖子'
      }
    }
  ],
  //轮播管理
  'platform/RotationManage': [
    {
      path: 'rotation_manage/new',
      name: 'NewRotation',
      component: RotationInfo,
      meta: {
        title: '新增轮播图'
      }
    },
    {
      path: 'rotation_manage/edit/:id',
      name: 'EditRotation',
      component: RotationInfo,
      meta: {
        title: '编辑轮播图'
      }
    }
  ],
  'community/RotationManage': [
    {
      path: 'rotation_manage/new',
      name: 'NewRotation',
      component: RotationInfo,
      meta: {
        title: '新增轮播图'
      }
    },
    {
      path: 'rotation_manage/edit/:id',
      name: 'EditRotation',
      component: RotationInfo,
      meta: {
        title: '编辑轮播图'
      }
    }
  ],
  //报修项目
  'platform/RepairItems': [
    {
      path: 'repair_items/new',
      name: 'NewRepairItems',
      component: RepairItemsInfo,
      meta: {
        title: '新增报修类型'
      }
    },
    {
      path: 'repair_items/edit/:id',
      name: 'EditRepairItems',
      component: RepairItemsInfo,
      meta: {
        title: '编辑报修项目'
      }
    }
  ],
  'community/RepairItems': [
    {
      path: 'repair_items/new',
      name: 'NewRepairItems',
      component: RepairItemsInfo,
      meta: {
        title: '新增报修项目'
      }
    },
    {
      path: 'repair_items/edit/:id',
      name: 'EditRepairItems',
      component: RepairItemsInfo,
      meta: {
        title: '编辑报修项目'
      }
    }
  ],
  //服务项目
  'platform/ServiceProject': [
    {
      path: 'service_project/new',
      name: 'NewServiceProject',
      component: ServiceProjectInfo,
      meta: {
        title: '新增服务项目'
      }
    },
    {
      path: 'service_project/edit/:id',
      name: 'EditServiceProject',
      component: ServiceProjectInfo,
      meta: {
        title: '编辑服务项目'
      }
    }
  ],
  'community/ServiceProject': [
    {
      path: 'service_project/new',
      name: 'NewServiceProject',
      component: ServiceProjectInfo,
      meta: {
        title: '新增服务项目'
      }
    },
    {
      path: 'service_project/edit/:id',
      name: 'EditServiceProject',
      component: ServiceProjectInfo,
      meta: {
        title: '编辑服务项目'
      }
    }
  ],
  //报修工单
  'platform/RepairOrder': [
    {
      path: 'repair_order/new',
      name: 'NewRepairOrder',
      component: RepairOrderInfo,
      meta: {
        title: '新增报修订单'
      }
    },
    {
      path: 'repair_order/info/:id',
      name: 'RepairOrderDetail',
      component: RepairOrderDetail,
      meta: {
        title: '报修订单详情'
      }
    }
  ],
  'community/ServiceProject': [
    {
      path: 'repair_order/new',
      name: 'NewRepairOrder',
      component: RepairOrderInfo,
      meta: {
        title: '新增报修订单'
      }
    },
    {
      path: 'repair_order/info/:id',
      name: 'RepairOrderDetail',
      component: RepairOrderDetail,
      meta: {
        title: '报修订单详情'
      }
    }
  ],
  //公式管理
  'platform/FormulaManage': [
    {
      path: 'formula_manage/new',
      name: 'NewFormula',
      component: FormulaInfo,
      meta: {
        title: '新增公式'
      }
    },
    {
      path: 'formula_manage/edit/:id',
      name: 'EditFormula',
      component: FormulaInfo,
      meta: {
        title: '编辑公式'
      }
    }
  ],
  'community/FormulaManage': [
    {
      path: 'formula_manage/new',
      name: 'NewFormula',
      component: FormulaInfo,
      meta: {
        title: '新增公式'
      }
    },
    {
      path: 'formula_manage/edit/:id',
      name: 'EditFormula',
      component: FormulaInfo,
      meta: {
        title: '编辑公式'
      }
    }
  ],
  //费项管理
  'platform/ExpendManage': [
    {
      path: 'expend_manage/new',
      name: 'NewExpend',
      component: ExpendInfo,
      meta: {
        title: '新增费项'
      }
    },
    {
      path: 'expend_manage/edit/:id',
      name: 'EditExpend',
      component: ExpendInfo,
      meta: {
        title: '编辑费项'
      }
    }
  ],
  'community/ExpendManage': [
    {
      path: 'expend_manage/new',
      name: 'NewExpend',
      component: ExpendInfo,
      meta: {
        title: '新增费项'
      }
    },
    {
      path: 'expend_manage/edit/:id',
      name: 'EditExpend',
      component: ExpendInfo,
      meta: {
        title: '编辑费项'
      }
    }
  ],
  //车位管理
  'platform/ParkingManage': [
    {
      path: 'parking_manage/area/new',
      name: 'NewParkingArea',
      component: ParkingAreaInfo,
      meta: {
        title: '新增车位分区'
      }
    },
    {
      path: 'parking_manage/area/edit/:id',
      name: 'EditParkingArea',
      component: ParkingAreaInfo,
      meta: {
        title: '编辑车位分区'
      }
    },
    {
      path: 'parking_manage/:id/register',
      name: 'ParkingRegister',
      component: ParkingRegister,
      meta: {
        title: '车位登记'
      }
    }
  ],
  'community/ParkingManage': [
    {
      path: 'parking_manage/area/new',
      name: 'NewParkingArea',
      component: ParkingAreaInfo,
      meta: {
        title: '新增车位分区'
      }
    },
    {
      path: 'parking_manage/area/edit/:id',
      name: 'EditParkingArea',
      component: ParkingAreaInfo,
      meta: {
        title: '编辑车位分区'
      }
    },
    {
      path: 'parking_manage/:id/register',
      name: 'ParkingRegister',
      component: ParkingRegister,
      meta: {
        title: '车位登记'
      }
    }
  ],
}